import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { GenericSubSection } from '../common/GenericSubSection';
import { useExteriorSectionData } from '../../hooks/useExteriorSection';
import { useLevel1SectionData } from '../../hooks/useLevel1Section';
import { useGetVehicleId } from 'pages/CreateVehicle/hooks/useGetVehicleId';
import { useGetSectionsQuery } from 'services/api/vehicle-sections';
import { skipToken } from '@reduxjs/toolkit/query';
import { useExteriorVideo } from '../../hooks/useExteriorVideo';

export const ExteriorLevel3 = () => {
  const { images, subSections } = useExteriorSectionData('exterior');
  const { subSections: interiorSections } = useLevel1SectionData('interior_questions');
  const exteriorPaint = subSections.exterior_paint;
  const windshield = interiorSections.windshield;

  const video = useExteriorVideo()

  return (
    <Level2Wrapper flex="1 1 100%" label="Exterior">
      <ImageList video={video} label="Exterior Pictures" images={images.filter((img: any) => !!img.url)} />
      {windshield && !!windshield.grade && <GenericSubSection section={windshield} />}
      {exteriorPaint && !!exteriorPaint.grade && <GenericSubSection section={exteriorPaint} />}
    </Level2Wrapper>
  );
};
